import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { WorkOrderComplementStatusNumber } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDisclosure } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { DateTimeFormat } from '@/utils/moment';
import { Statistic, Tooltip } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';

interface Props {
  value?: number;
}

const WorkOrdersOpenMonth: React.FC<Props> = ({ value }) => {
  const [viewWorkOrdersOpen, viewWorkOrdersActions] = useDisclosure();

  return (
    <>
      <div
        className={classNames('header-statistic-action', {
          '--disabled': !hasPermissions([
            Authorities.MOVIMENTATION_WORKORDER_VIEW,
          ]),
        })}
        onClick={viewWorkOrdersActions.open}
      >
        <Tooltip title="Quantidade de orçamentos abertos no mes atual.">
          <Statistic
            value={value}
            title={`Abertos - ${moment().format('MMM/YYYY').toUpperCase()}`}
          />
        </Tooltip>
      </div>

      <WorkOrdersListModal
        open={viewWorkOrdersOpen}
        onCancel={viewWorkOrdersActions.close}
        queryFilter={{
          status: [WorkOrderComplementStatusNumber.Open],
          entryInitialDate: moment().startOf('month').format(DateTimeFormat),
          entryFinalDate: moment().endOf('month').format(DateTimeFormat),
        }}
      />
    </>
  );
};

export default WorkOrdersOpenMonth;
